"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function get() {
    return _Header["default"];
  }
});
Object.defineProperty(exports, "Footer", {
  enumerable: true,
  get: function get() {
    return _Footer["default"];
  }
});
Object.defineProperty(exports, "Layout", {
  enumerable: true,
  get: function get() {
    return _Layout["default"];
  }
});
Object.defineProperty(exports, "Home", {
  enumerable: true,
  get: function get() {
    return _Home["default"];
  }
});
Object.defineProperty(exports, "Travel", {
  enumerable: true,
  get: function get() {
    return _Travel["default"];
  }
});
Object.defineProperty(exports, "BlankPage", {
  enumerable: true,
  get: function get() {
    return _BlankPage["default"];
  }
});
Object.defineProperty(exports, "View", {
  enumerable: true,
  get: function get() {
    return _View["default"];
  }
});
Object.defineProperty(exports, "Banner", {
  enumerable: true,
  get: function get() {
    return _Banner["default"];
  }
});
Object.defineProperty(exports, "Card", {
  enumerable: true,
  get: function get() {
    return _Card["default"];
  }
});
Object.defineProperty(exports, "ModalView", {
  enumerable: true,
  get: function get() {
    return _Modal["default"];
  }
});
Object.defineProperty(exports, "Blogs", {
  enumerable: true,
  get: function get() {
    return _Blogs["default"];
  }
});
Object.defineProperty(exports, "LikeShare", {
  enumerable: true,
  get: function get() {
    return _likeShare["default"];
  }
});
Object.defineProperty(exports, "BlogSideBar", {
  enumerable: true,
  get: function get() {
    return _blogSidebar["default"];
  }
});
Object.defineProperty(exports, "Tabs", {
  enumerable: true,
  get: function get() {
    return _reactBootstrapTabs.Tabs;
  }
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function get() {
    return _reactBootstrapTabs.Tab;
  }
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Main = _interopRequireDefault(require("./container/Main"));

var _Header = _interopRequireDefault(require("./container/Header"));

var _Footer = _interopRequireDefault(require("./container/Footer"));

var _Layout = _interopRequireDefault(require("./container/Layout"));

var _Home = _interopRequireDefault(require("./components/Home"));

var _Travel = _interopRequireDefault(require("./components/Travel"));

var _BlankPage = _interopRequireDefault(require("./container/BlankPage"));

var _View = _interopRequireDefault(require("./components/View"));

var _Banner = _interopRequireDefault(require("./container/Banner"));

var _Card = _interopRequireDefault(require("./container/Card"));

var _Modal = _interopRequireDefault(require("./container/Modal"));

var _Blogs = _interopRequireDefault(require("./container/Blogs"));

var _likeShare = _interopRequireDefault(require("./container/BlogView/like-share"));

var _blogSidebar = _interopRequireDefault(require("./container/BlogView/blog-sidebar"));

var _reactBootstrapTabs = require("react-bootstrap-tabs");

var _context = require("./context");

require("bootstrap/dist/css/bootstrap.css");

require("./components/theme/theme.sass");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var WebTemplates = /*#__PURE__*/function (_Component) {
  _inherits(WebTemplates, _Component);

  var _super = _createSuper(WebTemplates);

  function WebTemplates(props) {
    _classCallCheck(this, WebTemplates);

    return _super.call(this, props);
  }

  _createClass(WebTemplates, [{
    key: "getColorsName",
    value: function getColorsName(color) {
      return color.label.toLowerCase().replace(/ /g, "-");
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$data, _ref;

      var colorsData = ((_this$props$data = this.props.data) === null || _this$props$data === void 0 ? void 0 : _this$props$data.colors) || {};
      var colors = typeof colorsData === 'string' ? JSON.parse(colorsData) : colorsData;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_context.MainContext.Provider, {
        value: this.props.data
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "wizrd-blog-theme wizard-style-theme",
        style: (_ref = {}, _defineProperty(_ref, '--top-menu', colors['top-menu']), _defineProperty(_ref, '--top-menu-font', colors['top-menu-font']), _defineProperty(_ref, '--button', colors['button']), _defineProperty(_ref, '--button-font', colors['button-font']), _defineProperty(_ref, '--home-background', colors['home-background']), _defineProperty(_ref, '--home-background-font', colors['home-background-font']), _defineProperty(_ref, '--background', colors['background']), _defineProperty(_ref, '--background-font', colors['background-font']), _defineProperty(_ref, '--header-color', colors['header-color']), _defineProperty(_ref, '--header-background', colors['header-background']), _defineProperty(_ref, '--box-shadow', colors['box-shadow'] || '#000000'), _ref)
      }, /*#__PURE__*/_react["default"].createElement(_Main["default"], null, this.props.children))));
    }
  }]);

  return WebTemplates;
}(_react.Component);

exports["default"] = WebTemplates;